<ng-container #container >
</ng-container>

<ng-template #content>
    <img
        class="{{format}}"
        [ngClass]="{'min': min === true}"
        class=""
        [src]="src"
        alt="{{alt}}"
        (load)="onImgLoad()"
    />
</ng-template>
